import Base from '../../ts/_base';
/* 
adding the ability to navigate through the bootstrap menu
items by click on keyboard alphabits
*/

export default class DropdownSearch extends Base {
    
    private get childSelectors(): {[key: string]: string} {
        return {
            ...this.selectors,
            dropdownMenu: '.dropdown.show',
            dropdownItem: '.dropdown-item'
        }
    }

    constructor() {
        super();
        this.controller = this.controller.bind(this);
    }

    initialize(): void {
        this.subscribeToEvent('keydown', this.childSelectors.dropdownMenu, this.controller);
    }

    controller(e: KeyboardEvent): void {
        const {key, currentTarget} = e;
        const dropdownItems = this.queryElm(this.childSelectors.dropdownItem, true, currentTarget as HTMLElement) as NodeListOf<HTMLElement>;
        for(const elm of (dropdownItems as any))
            if((elm.innerText || '').toLowerCase().startsWith(key)) {
                elm.focus();
                return;
            }
    }
}